import React from 'react';
import { Availability } from '../types/catalog';
const styles: Record<Availability, string> = {
  'Entrega inmediata': 'bg-neon/20 text-neon-hi border-neon/50',
  Disponible: 'bg-ok/15 text-ok border-ok/30',
  'A pedido': 'bg-warn/15 text-warn border-warn/30',
  'Sin stock': 'bg-graphite text-mist border-line'
};
export function AvailabilityBadge({
  value
}: {
  value: Availability;
}) {
  return <span className={`inline-flex items-center rounded-full border px-2.5 py-1 text-[11px] font-semibold backdrop-blur ${styles[value]}`} data-id="element-391" data-mp="jbdyqx6d5j76">
      {value}
    </span>;
}